export type NotificationReviewAction = "review" | "acknowledge" | "complete_task" | "snooze_15m";

export type NotificationActionSearch = {
  eylem: NotificationReviewAction;
  hatirlatici?: string;
  surum?: number;
  gorev?: string;
  gorev_surumu?: number;
  teslimat?: string;
};

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const ACTIONS = new Set<NotificationReviewAction>([
  "review",
  "acknowledge",
  "complete_task",
  "snooze_15m",
]);

function uuid(value: unknown) {
  return typeof value === "string" && UUID.test(value) ? value.toLowerCase() : undefined;
}

function revision(value: unknown) {
  const parsed = typeof value === "string" && /^\d+$/.test(value) ? Number(value) : value;
  return Number.isSafeInteger(parsed) && Number(parsed) > 0 && Number(parsed) <= 2147483647
    ? Number(parsed)
    : undefined;
}

/** Drop every unrecognised field before the authenticated page sees it. */
export function validateNotificationActionSearch(
  search: Record<string, unknown>,
): NotificationActionSearch {
  return {
    eylem:
      typeof search.eylem === "string" && ACTIONS.has(search.eylem as NotificationReviewAction)
        ? (search.eylem as NotificationReviewAction)
        : "review",
    hatirlatici: uuid(search.hatirlatici),
    surum: revision(search.surum),
    gorev: uuid(search.gorev),
    gorev_surumu: revision(search.gorev_surumu),
    teslimat: uuid(search.teslimat),
  };
}
